import BaseAPI from "../api";

const path: string = "reports";

type getProps = {
  idFiscalYear?: number;
  format?: string;
};
type getReportProps = {
  idFiscalYear?: number;
  format?: string;
  idDepartment?: number;
};
type equipmentType = {
  idFiscalYear?: number;
  idDepartment?: number;
};
type equipmentFileType = {
  idFiscalYear?: number;
  idDepartment?: number;
  format?: string;
};

export class ReportApi extends BaseAPI {
  public static getFile(props: getProps): Promise<any> {
    return this.api
      .get(`${path}/track-summary-report/file`, {
        responseType: "arraybuffer",
        params: { ...props },
      })
      .then((res) => res);
  }

  static getTrackOverview(props: getReportProps): Promise<any> {
    return this.api
      .get(`${path}/track-overview-report/data`, { params: { ...props } })
      .then((res) => res);
  }
  static getFileTrackOverview(props: getReportProps): Promise<any> {
    return this.api
      .get(`${path}/track-overview-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }
  static getTrackDetail(props: getReportProps): Promise<any> {
    return this.api
      .get(`${path}/track-detail-report/data`, { params: { ...props } })
      .then((res) => res);
  }
  static getFileTrackDetail(props: getReportProps): Promise<any> {
    return this.api
      .get(`${path}/track-detail-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getEquipmentSummaryReport(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/equipment-summary-report/data`, { params: { ...props } })
      .then((res) => res);
  }
  static getFileEquipmentSummaryReport(props: equipmentFileType): Promise<any> {
    return this.api
      .get(`${path}/equipment-summary-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getEquipmentDetailReport(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/equipment-detail-report/data`, { params: { ...props } })
      .then((res) => res);
  }
  static getFileEquipmentDetailFileReport(
    props: equipmentFileType
  ): Promise<any> {
    return this.api
      .get(`${path}/equipment-detail-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getProgressReportData(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/progress-report/data`, {
        params: { ...props },
      })
      .then((res) => res);
  }
  static getProgressReportFile(props: equipmentFileType): Promise<any> {
    return this.api
      .get(`${path}/progress-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getBudgetReport(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/budget-report/data`, { params: { ...props } })
      .then((res) => res);
  }
  static getBudgetReportFile(props: equipmentFileType): Promise<any> {
    return this.api
      .get(`${path}/budget-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getEvaluationReport(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/evaluation-report/data`, {
        params: { ...props },
      })
      .then((res) => res);
  }
  static getEvaluationReportFile(props: equipmentFileType): Promise<any> {
    return this.api
      .get(`${path}/evaluation-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }

  static getColorfulReport(props: equipmentType): Promise<any> {
    return this.api
      .get(`${path}/colorful-report/data`, {
        params: { ...props },
      })
      .then((res) => res);
  }
  static getEColorfulReportFile(props: equipmentFileType): Promise<any> {
    return this.api
      .get(`${path}/colorful-report/file`, {
        params: { ...props },
        responseType: "arraybuffer",
      })
      .then((res) => res);
  }
}
